import { MotorDataType } from '@e2m-customer-portal/domains';

export function itemsFilteredByGroup(items: Map<string, MotorDataType>, groupName: string | null) {
  return new Map([...items].filter(([, data]) => data.target_rated_power_group === groupName));
}

export interface OptimizationSchedule {
  minutes: number;
  hours: number;
  daysOfWeek: string[] | undefined;
}

export const getOptimizationSchedule = (cronString: string | null): OptimizationSchedule | null => {
  if (!cronString) return null;
  const parts = cronString?.split(' ');
  const minutes = +parts[0];
  const hours = +parts[1];
  const daysOfWeek: string[] | undefined =
    parts[4] === '*' ? [...new Array(7).keys()].map(String) : parts[4].split(','); // Get the day-of-week field
  return { minutes, hours, daysOfWeek };
};
